import React from "react";
import { partners } from "../../data/mock";
import { Shield, Cpu, Cloud, Network, Zap, Sparkles, Server, Lock, Globe, Award } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

const iconMap = { Cisco: Network, Microsoft: Cpu, Fortinet: Shield, "Palo Alto": Lock, Juniper: Server, Aruba: Zap, AWS: Cloud, "Google Cloud": Globe, "Azure OpenAI": Sparkles, Genesys: Award };

export default function PartnerBar() {
  const { t } = useLanguage();
  const doubled = [...partners, ...partners];
  return (
    <section className="relative py-14 border-y border-cyan-400/10" style={{ background: "linear-gradient(180deg, #050818, #060b1e 50%, #050818)" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-8">
          <div className="text-[11px] tracking-[0.22em] uppercase text-cyan-300 font-semibold">{t("partners.title")}</div>
        </div>
        <div className="relative overflow-hidden" style={{ maskImage: "linear-gradient(90deg, transparent, black 15%, black 85%, transparent)", WebkitMaskImage: "linear-gradient(90deg, transparent, black 15%, black 85%, transparent)" }}>
          <div className="flex marquee gap-10 w-max">
            {doubled.map((p, i) => {
              const Icon = iconMap[p] || Sparkles;
              return (
                <div key={i} className="flex items-center gap-3 shrink-0 opacity-80 hover:opacity-100 transition">
                  <Icon className="w-5 h-5 text-cyan-300" strokeWidth={1.8} />
                  <span className="font-display text-lg font-semibold text-slate-200 tracking-wide whitespace-nowrap">{p}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
